import Rate from './Rate';
export default Rate;


//////////////////
// WEBPACK FOOTER
// ../~/rc-rate/es/index.js
// module id = 2000
// module chunks = 1